import { render, staticRenderFns } from "./save_food.vue?vue&type=template&id=5c4d75c0&scoped=true&lang=html&"
import script from "./save_food.vue?vue&type=script&lang=js&"
export * from "./save_food.vue?vue&type=script&lang=js&"
import style0 from "./save_food.vue?vue&type=style&index=0&id=5c4d75c0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4d75c0",
  null
  
)

export default component.exports